<template>
  <div class="selectable">
    <el-form class="form" ref="form" :model="form" label-width="140px">
      <el-form-item label="预约按钮">
        <el-input v-model="form.book_button_text" style="width:400px"></el-input>
      </el-form-item>
      <el-form-item label="转发标题">
        <el-input v-model="form.share_title" style="width:400px"></el-input>
      </el-form-item>
      <el-form-item label="转发封面图">
        <img class="thumb-img" v-if="form.share_thumb" :src="form.share_thumb" @click="selectThumb('share_thumb')">
        <el-button v-else size="small" @click="selectThumb('share_thumb')">选择图片</el-button>
      </el-form-item>
      <el-form-item label="提交预约按钮">
        <el-input v-model="form.submit_button_text" style="width:400px"></el-input>
      </el-form-item>
      <el-form-item label="活动回顾按钮的路径">
        <!-- <link-to v-model="form.review_link"></link-to> -->
        <el-input v-model="form.review_path" style="width:400px"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submit">立即保存</el-button>
      </el-form-item>
    </el-form>
    <upload-img ref="upload"></upload-img>
  </div>
</template>
<script>
import linkTo from '@/components/link/link'
import UploadImg from '@/components/UploadImg'
export default {
  name: 'selectable',
  components: {
    UploadImg,
    linkTo
  },
  props: {
    form: {
      type: Object
    }
  },
  methods: {
    selectThumb (key) {
      let list = []
      if (this.form[key]) {
        list = [this.form[key]]
      }
      this.$refs.upload.show(list, 'other', 1).then(res => {
        if (res.length) {
          this.form[key] = res[0]
        }
      }).catch(_ => {})
    },
    submit () {
      this.$emit('submit')
    }
  }
}
</script>
<style lang="less" scoped>
.thumb-img {
  cursor: pointer;
  height: 60px;
  width: auto;
}
</style>



// WEBPACK FOOTER //
// src/views/booking/components/selectable.vue